/* =====================================================================
   You Fly LA · Fleet "Flight Deck" pages (r16, 2026-09-30, theme v55) · assets/yfla-fleet-deck.js
   Markup: sections/yfla-fleet-hangar.liquid (overview) and sections/yfla-aircraft-deck.liquid (model + tail pages).
   Data lives in snippets/yfla-fleet-deck-data.liquid; the sections print everything this script needs into the page,
   so it only moves state around (no data of its own, no network).
   Overview: postcard readouts (pin), tail chips swap the postcard photo, compare picker (up to 3), training ladder.
   Aircraft page: tail switches (hero, badge, note, walk-around, receipt, gallery filter), walk-around hotspots, the
   "Fly It Three Ways" tabs, the hour receipt, the weight checker.
   Both: gallery filter + photo viewer (modal dialog: focus kept inside, Esc closes, focus returns), FAQ accordion,
   the "Full Specs & Guide" Show More on phones, the desktop call pill (hidden once the footer curtain starts to open).
   ===================================================================== */
(function () {
  'use strict';
  var d = document;
  function qa(s, r) { return [].slice.call((r || d).querySelectorAll(s)); }
  function q(s, r) { return (r || d).querySelector(s); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }
  function pressed(el, v) { if (el) el.setAttribute('aria-pressed', v ? 'true' : 'false'); }
  function json(s) { try { return JSON.parse(s); } catch (e) { return null; } }
  function setImg(img, o) {
    if (!img || !o) return;
    if (o.srcset) img.setAttribute('srcset', o.srcset); else img.removeAttribute('srcset');
    img.src = o.src; img.alt = o.alt || '';
    if (o.w && o.h) { img.setAttribute('width', o.w); img.setAttribute('height', o.h); }
  }
  function orig(img) {
    return { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') || '', alt: img.getAttribute('alt') || '', w: img.getAttribute('width'), h: img.getAttribute('height') };
  }

  /* ---------- FAQ: one open at a time ---------- */
  function faq(root) {
    var items = qa('.faq-item', root);
    items.forEach(function (it) {
      var b = q('.faq-q', it), a = q('.faq-a', it);
      on(b, 'click', function () {
        var open = b.getAttribute('aria-expanded') !== 'true';
        items.forEach(function (o) {
          var ob = q('.faq-q', o), oa = q('.faq-a', o);
          o.classList.remove('is-open'); ob.setAttribute('aria-expanded', 'false'); oa.hidden = true;
        });
        if (open) { it.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); a.hidden = false; }
      });
    });
  }

  /* ---------- gallery filter + photo viewer ---------- */
  function gallery(root) {
    var list = q('[data-fd="gal"]', root), dlg = q('dialog.lb', root);
    if (!list) return null;
    var items = qa('.gal-item', list), chips = qa('.chips [data-gf]', root);
    var shown = items.slice(), cur = 0, opener = null;
    function filter(v) {
      shown = [];
      items.forEach(function (li) {
        var t = (li.getAttribute('data-t') || '').split(' ');
        var ok = v === 'all' || t.indexOf(v) >= 0;
        li.hidden = !ok; li.classList.remove('g-big', 'g-wide');
        if (ok) shown.push(li);
      });
      list.classList.toggle('gal-all', v === 'all'); list.classList.toggle('gal-few', v !== 'all');
      if (v === 'all' && shown[0]) { shown[0].classList.add('g-big'); if (shown.length > 7 && shown[5]) shown[5].classList.add('g-wide'); }
      chips.forEach(function (c) { var s = c.getAttribute('data-gf') === v; c.classList.toggle('is-on', s); pressed(c, s); });
    }
    chips.forEach(function (c) { on(c, 'click', function () { filter(c.getAttribute('data-gf')); }); });
    if (!dlg || typeof dlg.showModal !== 'function') return { filter: filter, has: function (v) { return chips.some(function (c) { return c.getAttribute('data-gf') === v; }); } };
    var img = q('[data-lb="img"]', dlg), cap = q('[data-lb="cap"]', dlg), n = q('[data-lb="n"]', dlg), of = q('[data-lb="of"]', dlg);
    function show(i) {
      if (!shown.length) return;
      cur = (i + shown.length) % shown.length;
      var b = q('.gal-btn', shown[cur]);
      img.removeAttribute('srcset'); img.src = b.getAttribute('data-full'); img.alt = b.getAttribute('data-alt') || '';
      cap.textContent = b.getAttribute('data-cap') || ''; n.textContent = cur + 1; of.textContent = shown.length;
    }
    function close() { if (dlg.open) dlg.close(); d.documentElement.classList.remove('yffd-lb-open'); if (opener) { try { opener.focus(); } catch (e) {} } }
    items.forEach(function (li) {
      var b = q('.gal-btn', li);
      on(b, 'click', function () {
        opener = b; show(shown.indexOf(li));
        dlg.showModal(); d.documentElement.classList.add('yffd-lb-open');
        q('[data-lb="close"]', dlg).focus();
      });
    });
    on(q('[data-lb="close"]', dlg), 'click', close);
    on(q('[data-lb="prev"]', dlg), 'click', function () { show(cur - 1); });
    on(q('[data-lb="next"]', dlg), 'click', function () { show(cur + 1); });
    on(dlg, 'cancel', function (e) { e.preventDefault(); close(); });
    on(dlg, 'click', function (e) { if (e.target === dlg) close(); });
    on(dlg, 'keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); show(cur - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); show(cur + 1); }
      else if (e.key === 'Tab') {
        var f = qa('button', dlg), first = f[0], last = f[f.length - 1];
        if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    return { filter: filter, has: function (v) { return chips.some(function (c) { return c.getAttribute('data-gf') === v; }); } };
  }

  /* ---------- "Full Specs & Guide": collapsed on phones ---------- */
  function guide(root) {
    var card = q('.gd-card', root), body = q('.gd-body', root), more = q('.gd-more', root);
    if (!card || !body || !more) return;
    var btn = q('button', more), mq = window.matchMedia('(max-width: 760px)'), user = false;
    function set(open) { card.classList.toggle('is-collapsed', !open); btn.setAttribute('aria-expanded', open ? 'true' : 'false'); btn.textContent = open ? 'Show Less' : 'Show More'; }
    function fit() {
      if (!mq.matches) { more.hidden = true; card.classList.remove('is-collapsed'); return; }
      if (body.scrollHeight < 760) { more.hidden = true; card.classList.remove('is-collapsed'); return; }
      more.hidden = false; if (!user) set(false);
    }
    on(btn, 'click', function () {
      user = true; var open = btn.getAttribute('aria-expanded') !== 'true'; set(open);
      if (!open) card.scrollIntoView({ block: 'start' });
    });
    if (mq.addEventListener) mq.addEventListener('change', fit); else if (mq.addListener) mq.addListener(fit);
    fit(); window.setTimeout(fit, 1500);
  }

  /* ---------- desktop call pill: off once the footer curtain starts to open ---------- */
  function pill(root) {
    var p = q('.pill', root), end = q('.yffd-end', root);
    if (!p || !end || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) { es.forEach(function (e) { p.classList.toggle('is-off', e.isIntersecting || e.boundingClientRect.top < 0); }); }, { rootMargin: '0px 0px 40px 0px' }).observe(end);
  }

  /* ---------- overview: postcards ---------- */
  function cards(root) {
    var list = qa('.pc', root);
    list.forEach(function (pc) {
      var peek = q('.pc-peek', pc);
      on(peek, 'click', function () {
        var open = !pc.classList.contains('is-pin');
        list.forEach(function (o) { o.classList.remove('is-pin'); var ob = q('.pc-peek', o); if (ob) ob.setAttribute('aria-expanded', 'false'); });
        if (open) { pc.classList.add('is-pin'); peek.setAttribute('aria-expanded', 'true'); }
      });
      var img = q('.pc-photo img', pc), note = q('.pc-tailnote', pc), base = img ? orig(img) : null;
      qa('.tail', pc).forEach(function (t) {
        var data = json(t.getAttribute('data-photo') || '');
        function enter() { qa('.tail', pc).forEach(function (o) { o.classList.remove('is-on'); }); t.classList.add('is-on'); if (data && data.img) setImg(img, data.img); if (note && data) note.textContent = data.note || ''; }
        function leave() { t.classList.remove('is-on'); if (base) setImg(img, base); if (note) note.textContent = ''; }
        on(t, 'mouseenter', enter); on(t, 'focus', enter); on(t, 'mouseleave', leave); on(t, 'blur', leave);
      });
    });
  }

  /* ---------- overview: compare (up to 3, in the order picked) ---------- */
  function compare(root) {
    var box = q('[data-fd="cmp"]', root), table = q('[data-fd="cmptable"]', root);
    if (!box || !table) return;
    var max = parseInt(box.getAttribute('data-max'), 10) || 3, sel = [];
    qa('.cmp-pick .chip[data-cmp]', box).forEach(function (c) { if (c.getAttribute('aria-pressed') === 'true') sel.push(c.getAttribute('data-cmp')); });
    var hints = ['pick two or three', 'pick at least one more', 'add a third or compare now', 'full: remove one to swap'];
    function render() {
      var full = sel.length >= max;
      qa('[data-col]', table).forEach(function (c) { var i = sel.indexOf(c.getAttribute('data-col')); c.hidden = i < 0; c.style.order = i < 0 ? '' : String(i + 1); });
      table.className = table.className.replace(/\bcols-\d\b/, '') + ' cols-' + Math.max(1, sel.length);
      table.hidden = sel.length === 0;
      var empty = q('[data-fd="cmpempty"]', box); if (empty) empty.hidden = sel.length > 0;
      qa('[data-fd="cmpn"]', root).forEach(function (n) { n.textContent = sel.length; });
      var h = q('[data-fd="cmph"]', box); if (h) h.textContent = hints[Math.min(sel.length, 3)];
      qa('[data-cmp]', root).forEach(function (b) {
        if (b.classList.contains('x-btn')) return;
        var id = b.getAttribute('data-cmp'), inC = sel.indexOf(id) >= 0;
        pressed(b, inC); b.classList.toggle('is-on', inC); b.disabled = !inC && full;
        if (b.classList.contains('cmp-btn')) {
          var short = b.getAttribute('data-short') || '', l = q('[data-fd="cmpl"]', b);
          if (l) l.textContent = inC ? 'Added' : 'Compare';
          b.setAttribute('aria-label', inC ? 'Remove ' + short + ' from comparison' : (full ? 'Compare is full: remove an aircraft first' : 'Add ' + short + ' to comparison'));
        }
      });
      qa('.pc', root).forEach(function (pc) { pc.classList.toggle('is-cmp', sel.indexOf(pc.getAttribute('data-id')) >= 0); });
    }
    function toggle(id) { var i = sel.indexOf(id); if (i >= 0) sel.splice(i, 1); else if (sel.length < max) sel.push(id); render(); }
    qa('[data-cmp]', root).forEach(function (b) {
      on(b, 'click', function () {
        var id = b.getAttribute('data-cmp');
        toggle(id);
        if (b.classList.contains('x-btn')) { var c = q('.cmp-pick .chip[data-cmp="' + id + '"]', box); if (c) c.focus(); }
      });
    });
    on(q('[data-fd="cmpclear"]', box), 'click', function () { sel = []; render(); });
    render();
  }

  /* ---------- overview: training ladder ---------- */
  function ladder(root) {
    var rail = q('[data-fd="rail"]', root);
    if (!rail) return;
    var n = parseInt(rail.getAttribute('data-n'), 10) || 6, stops = qa('.stop', rail), panels = qa('.lad-panel', root);
    var fill = q('[data-fd="railfill"]', rail), mark = q('[data-fd="railmark"]', rail), step = 0;
    function go(i, focusNav) {
      step = Math.max(0, Math.min(n - 1, i));
      stops.forEach(function (s, k) {
        s.classList.toggle('is-on', k === step); s.classList.toggle('is-past', k < step);
        pressed(q('.stop-btn', s), k === step); var h = q('.stop-here', s); if (h) h.hidden = k !== step;
      });
      panels.forEach(function (p, k) { p.hidden = k !== step; });
      if (fill) fill.style.width = (n > 1 ? step / (n - 1) * 100 : 0).toFixed(2) + '%';
      if (mark) mark.style.left = 'calc(24px + (100% - 48px) * ' + ((2 * step + 1) / (2 * n)).toFixed(4) + ')';
      if (focusNav) { var b = q('.lad-nav [data-step="' + focusNav + '"]', panels[step]); if (!b || b.disabled) b = q('.lad-nav button:not([disabled])', panels[step]); if (b) b.focus(); }
    }
    stops.forEach(function (s, k) { on(q('.stop-btn', s), 'click', function () { go(k); }); });
    panels.forEach(function (p) {
      qa('.lad-nav [data-step]', p).forEach(function (b) {
        on(b, 'click', function () { var dlt = parseInt(b.getAttribute('data-step'), 10); go(step + dlt, String(dlt)); });
      });
    });
  }

  /* ---------- aircraft page ---------- */
  function deck(root, gal) {
    var sws = qa('.sw[data-tail]', root);
    function setText(k, v) { qa('[data-fd="' + k + '"]', root).forEach(function (e) { e.textContent = v; }); }
    /* walk-around hotspots + list */
    var hs = qa('.hs', root), wl = qa('.wl', root), spot = 0;
    function pick(i) {
      spot = spot === i ? -1 : i;
      hs.forEach(function (h, k) { h.classList.toggle('is-on', k === spot); h.setAttribute('aria-expanded', k === spot ? 'true' : 'false'); });
      wl.forEach(function (w, k) { w.classList.toggle('is-on', k === spot); q('.wl-btn', w).setAttribute('aria-expanded', k === spot ? 'true' : 'false'); });
      var hud = q('.walk-hud', root);
      if (hud) {
        hud.hidden = spot < 0;
        if (spot >= 0) { var w = wl[spot]; setText('hud-t', (spot + 1) + ' · ' + q('.wl-t', w).textContent); setText('hud-f', q('.wl-fact', w).textContent); }
      }
    }
    hs.forEach(function (h, k) { on(h, 'click', function () { pick(k); }); });
    wl.forEach(function (w, k) { on(q('.wl-btn', w), 'click', function () { pick(k); }); });
    /* tail switches */
    sws.forEach(function (b) {
      var t = json(b.getAttribute('data-tail'));
      if (!t) return;
      on(b, 'click', function () {
        sws.forEach(function (o) { o.classList.toggle('is-on', o === b); pressed(o, o === b); });
        setImg(q('.whero-media img', root), t.hero);
        setText('frame', t.frame); setText('tname', t.t); setText('tsub', t.sub); setText('tnote', t.note); setText('tlab', t.link); setText('wtag', t.wtag);
        var a = q('[data-fd="tlink"]', root); if (a) a.setAttribute('href', t.url);
        var wn = q('[data-fd="wnote"]', root); if (wn) { wn.textContent = t.wnote || ''; wn.hidden = !t.wnote; }
        var wp = q('[data-fd="wphoto"]', root);
        if (wp && t.walk) { setImg(q('img', wp), t.walk); if (t.walk.w && t.walk.h) wp.style.aspectRatio = t.walk.w + ' / ' + t.walk.h; }
        (t.spots || []).forEach(function (xy, k) { if (hs[k]) { hs[k].style.left = xy[0] + '%'; hs[k].style.top = xy[1] + '%'; } });
        if (gal) gal.filter(gal.has(t.gf) ? t.gf : 'all');
      });
    });
    /* Fly It Three Ways */
    var segs = qa('.seg-btn', root), tps = qa('.tp', root);
    segs.forEach(function (s, k) {
      on(s, 'click', function () {
        segs.forEach(function (o, j) { o.classList.toggle('is-on', j === k); pressed(o, j === k); });
        tps.forEach(function (p, j) { p.hidden = j !== k; });
      });
    });
    /* receipt: add a ground lesson */
    var rc = q('.receipt', root), gt = q('[data-fd="gtoggle"]', root), gl = q('[data-fd="ground"]', root);
    on(gt, 'click', function () {
      var onv = gt.getAttribute('aria-pressed') !== 'true';
      pressed(gt, onv); gt.classList.toggle('is-on', onv); if (gl) gl.hidden = !onv;
      setText('rtotal', rc.getAttribute(onv ? 'data-total-g' : 'data-total'));
    });
    /* weight checker */
    var wt = q('[data-fd="wt"]', root);
    if (wt) {
      var per = +wt.getAttribute('data-per'), comb = +wt.getAttribute('data-comb'), name = wt.getAttribute('data-name'), scope = wt.getAttribute('data-scope'), over = wt.getAttribute('data-over');
      var ins = qa('input', wt), who = ins.length > 2 ? 'passenger' : 'person';
      var msgs = {
        idle: 'Enter a weight to check it against the ' + name + ' limits ' + scope + '.',
        ok: 'Within the published ' + name + ' limits ' + scope + ': ' + per + ' lb per ' + who + ', ' + comb + ' lb combined.',
        close: 'Close to the limit. Call and we will run the numbers with you.',
        over: over
      };
      var check = function () {
        var vals = ins.map(function (i) { var v = String(i.value || '').replace(/[^0-9]/g, '').slice(0, 3); if (i.value !== v) i.value = v; return parseInt(v, 10) || 0; });
        var sum = vals.reduce(function (a, b) { return a + b; }, 0), any = vals.some(function (v) { return v > 0; });
        var st = 'ok';
        if (!any) st = 'idle';
        else if (vals.some(function (v) { return v > per; }) || sum > comb) st = 'over';
        else if (vals.some(function (v) { return v > per - 10; }) || sum > comb - 20) st = 'close';
        wt.classList.remove('is-idle', 'is-ok', 'is-close', 'is-over'); wt.classList.add('is-' + st);
        setText('wsum', sum); setText('wmsg', msgs[st]);
        var f = q('[data-fd="wfill"]', wt); if (f) f.style.width = Math.min(100, Math.round(sum / comb * 100)) + '%';
      };
      ins.forEach(function (i) { on(i, 'input', check); });
      check();
    }
  }

  function init(root) {
    root.classList.add('yffd-js');
    faq(root);
    var gal = gallery(root);
    guide(root);
    pill(root);
    if (root.classList.contains('yffd-hangar')) { cards(root); compare(root); ladder(root); }
    else deck(root, gal);
  }
  function start() {
    qa('.yffd[data-yffd]').forEach(function (r) {
      if (r.getAttribute('data-yffd-ready')) return;
      r.setAttribute('data-yffd-ready', '1');
      try { init(r); } catch (e) { if (window.console) console.warn('yfla-fleet-deck', e); }
    });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();
